<template>
  <div class="password-input" @click.stop>
    <div class="password-input_title">
      <span class="close-icon j-close-pwd-dialog-btn" @click="handleClose"></span>
      {{title}}
    </div>
    <div class="password-input_tips" v-if="costPoints">
      <div class="platform-payment">
        支付：
        <span class="colorful">
          <span class="spec">{{costPoints}}</span>G幣
        </span>
      </div>
      <div class="payment-detail">
        道具價值{{price}}G幣
        <span v-if="coupon">，抵用券-{{coupon}}G幣</span>
      </div>
    </div>
    <div class="password-input_form">
      <label ref="input" max-length="6" class="label-input" :class="[costPoints? false: 'empty']">
        <input
          ref="tel"
          name="tel"
          type="tel"
          maxlength="6"
          autocomplete="off"
          v-model="password"
          class="hidden-input"
        />
        <span
          :key="item"
          class="sim-input"
          v-for="(item, index) in 6"
          :class="[index < password.length ? 'active' : false]"
        ></span>
      </label>
    </div>
  </div>
</template>

<script>
import viewport from '@/mixins/viewport'
export default {
  name: 'PasswordInput',
  mixins: [viewport],
  props: {
    title: {
      type: String,
      default: '請輸入二級密碼'
    },
    costPoints: {
      type: [String, Number],
      default: 0
    },
    price: {
      type: [String, Number],
      default: 0
    },
    coupon: {
      type: [String, Number],
      default: 0
    }
  },
  data () {
    return {
      password: ''
    }
  },
  watch: {
    password (val) {
      if (val.length && !/^\d{0,6}$/gi.test(val)) {
        this.password = val.slice(0, val.length - 1)
        return
      }
      if (val.length === 6) {
        this.$refs.tel.blur()
        this.$emit('complete', val)
      }
    }
  },
  methods: {
    clearPWD () {
      this.password = ''
    },
    focus () {
      this.$refs.tel.focus()
    },
    handleClose () {
      this.$emit('close')
    }
  },
  mounted () {
    this.initViewport()
    this.$refs.tel.focus()
  },
  beforeDestroy () {
    this.removeViewport()
  }
}
</script>

<style lang="scss" scoped>
.hidden-input {
  position: absolute;
  width: 240px;
  height: 38px;
  color: transparent;
  opacity: 0;
  z-index: -1;
  overflow: hidden;
  transform: scale(0);
}
.close-icon {
  top: 50%;
  left: 2vw;
  margin: 3px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  position: absolute;
  box-sizing: border-box;
  background: transparent;
  transform: translate3d(0, -50%, 0);
  transform: translate(0, -50%) \9;
  &:after,
  &:before {
    position: absolute;
    top: -3px;
    left: 11px;
    width: 1px;
    content: " ";
    height: 25px;
    background: #666666;
    transform: rotate(45deg);
  }
  &:before {
    transform: rotate(-45deg);
  }
}
.password-input {
  width: 276px;
  height: 257px;
  border-radius: 5px;
  box-sizing: border-box;
  background-color: #f4f4f4;
  &_title {
    height: 50px;
    font-size: 17px;
    color: #6d6d6d;
    text-align: center;
    position: relative;
    padding: 15px 15px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #ebebeb;
  }
  .platform-payment {
    color: #333;
    font-size: 12px;
    margin-top: 10px;
    .colorful {
      color: #e97d30;
    }
    .spec {
      font-size: 24px;
    }
  }
  .payment-detail {
    font-size: 12px;
    color: #b7b7b7;
  }
  .label-input {
    width: 240px;
    height: 38px;
    display: block;
    cursor: pointer;
    border-radius: 5px;
    margin: 35px auto 0;
    background-color: #fff;
    border: 1px solid #c9c9c9;
    &.empty {
      margin-top: 70px;
    }
    .sim-input {
      width: 40px;
      position: relative;
      pointer-events: none;
      display: inline-block;
      box-sizing: border-box;
      height: calc(100% + 1px);
      border-right: 1px solid #c9c9c9;
      &.active:after {
        top: 50%;
        left: 50%;
        width: 12px;
        height: 12px;
        content: " ";
        position: absolute;
        border-radius: 100%;
        background-color: #e97d30;
        transform: translate3d(-50%, -50%, 0);
        transform: translate(-50%, -50%) \9;
      }
      &:last-child {
        border-right: none;
      }
    }
  }
}
@media screen and (orientation: landscape) {
  .password-input {
    width: 279px;
    height: 183px;
    &_title {
      height: 47px;
    }
    .label-input {
      margin-top: 14px;
      &.empty {
        margin-top: 45px;
      }
    }
  }
}
</style>
